import { get } from '@/apis/client';

export interface SearchPayload {
  query: string;
  page?: number | string;
  limit?: number | string;
  sort_by?: string;
  content_type?: string;
}

export interface SearchGroupResult {
  slug: string;
  subtitle?: string;
  title: string;
  content_type: string;
  publish_date: string;
  score: number;
  chunk_count: number;
  content_uri: string;
}

export interface SearchResponseData {
  query: string;
  total: number;
  page: number;
  limit: number;
  content_type?: string;
  content_types?: string[];
  groups?: SearchGroupResult[];
  results?: SearchGroupResult[];
  type_counts?: Record<string, number>;
}

export const getAISearchResults = async (
  payload: SearchPayload,
): Promise<SearchResponseData | null> => {
  const queryParams = new URLSearchParams();

  queryParams.append('query', payload.query);
  queryParams.append('page', String(payload.page ?? 1));
  queryParams.append('limit', String(payload.limit ?? 30));

  if (payload.sort_by) queryParams.append('sort_by', payload.sort_by);
  if (payload.content_type) queryParams.append('content_type', payload.content_type);

  try {
    const data = await get(`search?${queryParams.toString()}`);
    if (data && data.error !== true) {
      return data as SearchResponseData;
    } else {
      throw new Error(`getAISearchResults API Error: ${data?.message || 'Unknown error'}`);
    }
  } catch (error) {
    console.error('[API] Error while fetching AI search results:', error);
    return null;
  }
};